const getters = {
    statsStatus: state => state.statsStatus,
    statsErrors: state => state.statsErrors,
    seasons: state => state.seasons,
    divisions: state => state.divisions,
    teams: state => state.teams,
    stats: state => state.stats,
    games: state => state.games,
}

export default getters
